import * as d3 from 'd3'
import 'd3-tip'

window.d3 = d3